import InputMask from 'react-input-mask';
import propTypes from 'prop-types';
import { StyledInput } from './styles';

const InputWithMask = ({ value, onChange, mask, ...rest }) => {
  return (
    <InputMask
      maskChar={null}
      mask={mask}
      value={value}
      onChange={onChange}
      {...rest}
    >
      {inputProps => <StyledInput {...inputProps} />}
    </InputMask>
  );
};

export default InputWithMask;

InputWithMask.propTypes = {
  value: propTypes.string.isRequired,
  onChange: propTypes.func.isRequired,
  mask: propTypes.string.isRequired,
};
